export { default as onSubmitAdmin } from './onSubmitAdmin';

export type { OnSubmitAdminFunction, OnSubmitAdminPayload } from './onSubmitAdmin.type';
